export default __webpack_public_path__ + "static/media/DDD-centre-of-intelligence.1f053ee2.jpg";